"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./checkbox.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function Checkbox(props) {
  var className = props.className,
      value = props.value,
      size = props.size,
      onClick = props.onClick,
      checked = props.checked,
      inputProps = props.inputProps;
  var wrapperClassName = (0, _classnames.default)('checkbox-wrapper block relative cursor-pointer', {
    'checkbox-size-small': size === 'small',
    'checkbox-size-large': size === 'large'
  }, className);
  var checkboxSpanClassName = (0, _classnames.default)('checkbox-span absolute top-0 left-0 bg-transparent rounded-sm border-gray-400 border', {
    'checkbox-size-small': size === 'small',
    'checkbox-size-large': size === 'large'
  });

  var identifier = _lodash.default.get(inputProps, 'id') || _lodash.default.get(inputProps, 'value');

  return _react.default.createElement("label", {
    className: wrapperClassName,
    htmlFor: identifier
  }, _react.default.createElement("input", _extends({
    type: "checkbox",
    value: value,
    checked: checked,
    className: "absolute cursor-pointer opacity-0",
    readOnly: true
  }, inputProps)), _react.default.createElement("span", {
    className: checkboxSpanClassName,
    onClick: onClick
  }));
}

Checkbox.propTypes = {
  size: _propTypes.default.oneOf(['small', 'large']),
  className: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onClick: _propTypes.default.func.isRequired,
  checked: _propTypes.default.bool.isRequired,
  inputProps: _propTypes.default.object
};
Checkbox.defaultProps = {
  className: '',
  size: 'small',
  inputProps: {}
};

var _default = _react.default.memo(Checkbox);

exports.default = _default;